module.exports = function facebookSharer( url ) {
    const u = encodeURIComponent(url);
        
    window.open (
        'https://www.facebook.com/sharer/sharer.php?u=' + u,
        'popup',
        'width=600, height=400, scrollbars=no'
    );
};



// WEBPACK FOOTER //
// ./app/scripts/util/facebook-share.js